class CustomDrawer {
  constructor(drawerId, drawerTrigger) {
    this.config = {
      open: '.js-drawer-open-' + drawerTrigger,
      close: '.drawer__close-button',
      outsideClose: '.js-drawer-close-' + drawerTrigger,
    };
    this.drawer = document.querySelector(`#${drawerId}`);
    this.init();
  }

  init = () => {
    document
      .querySelectorAll(this.config.open)
      .forEach((el) => el.addEventListener('click', this.open));
    document
      .querySelectorAll(this.config.outsideClose)
      .forEach((el) => el.addEventListener('click', this.close));
    this.drawer
      ?.querySelector(this.config.close)
      ?.addEventListener('click', this.close);
  };

  initWindowListener = () => {
    document.addEventListener('click', this.onClickOutside);
  };

  deleteWindowListener = () => {
    document.removeEventListener('click', this.onClickOutside);
  };

  open = (e) => {
    e.preventDefault();
    this.drawer.classList.add('is-transitioning');
    setTimeout(() => {
      this.drawer.classList.remove('is-transitioning');
      this.drawer.classList.add('drawer--is-open');
      this.initWindowListener();
    }, 100);
    this.setLockScroll();
  };

  close = () => {
    this.deleteWindowListener();
    this.drawer.classList.remove('drawer--is-open');
    this.drawer.classList.add('is-transitioning');
    setTimeout(() => this.drawer.classList.remove('is-transitioning'), 500);
    this.removeLockScroll();
  };

  setLockScroll = () => {
    this.hasLockScrollBefore = document.documentElement.classList.contains(
      'js-drawer-open',
      'lock-scroll',
    );
    document.documentElement.classList.add('js-drawer-open', 'lock-scroll');
  };

  removeLockScroll = () => {
    if (this.hasLockScrollBefore) {
      this.hasLockScrollBefore = false;
      return;
    }
    document.documentElement.classList.remove('js-drawer-open', 'lock-scroll');
  };

  onClickOutside = (e) => {
    if (this.isOpen === false) {
      return;
    }
    const el = e.target;
    if (el !== this.drawer && !this.drawer.contains(el)) {
      this.close();
    }
  };
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomDrawer('CartNoteDrawer', 'cart-note');
  new CustomDrawer('GiftBoxDrawer', 'gift-box');
});
